module.exports = "/_next/static/images/img__notice_desktop-649a0c68401c480d81b577ac87022a39.png";